import React, { useState, useEffect } from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import { Title } from 'react-admin';


import { Dots } from 'react-activity';
import 'react-activity/dist/Dots.css';

import App from '../../../../app.js';


export default () => {

	const theapp = App.getAppObject();

	let splashinfo = 'Primus Money\nAll rights reserved';

	const [dev_message, setDevMessage] = useState('');

	return (
		<Card>
			<Title title="Splash Screen" />
			<CardContent>
			<div className="Container">
				<div className="Splash">
					<div>{splashinfo}</div>
					<div></div>
					<div>{dev_message}</div>
					<div></div>
					<div>loading app...</div>
					<Dots />
					<div></div>
				</div>
			</div>
			</CardContent>
		</Card>
	);
};